module.exports = __webpack_public_path__ + "img/BOARD.1fa6286a.svg";